import { render, staticRenderFns } from "./Duplicados.vue?vue&type=template&id=c8301d74"
import script from "./Duplicados.vue?vue&type=script&lang=js"
export * from "./Duplicados.vue?vue&type=script&lang=js"
import style0 from "./Duplicados.vue?vue&type=style&index=0&id=c8301d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports